import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Box } from "@outschool/backpack";
import { Container } from "@outschool/ui-legacy-component-library";
import { responsive } from "@outschool/ui-utils";
import React from "react";

import { headingOptions } from "../../components/contentful/ContentfulRenderOptions";

export default function BasicPageContent({ page }: { page: any }) {
  const { body } = page;
  return (
    <Container
      size="small"
      sx={{
        marginY: responsive({ default: "large", medium: "xlarge" }),
        minHeight: "50vh"
      }}
    >
      <Box
        sx={{
          "& p": {
            marginBottom: "1em",
            whiteSpace: "pre-wrap"
          },

          "& ul": {
            padding: "revert"
          }
        }}
      >
        {documentToReactComponents(body.json, headingOptions)}
      </Box>
    </Container>
  );
}
